// src/subscreens/admin/adminBiddingDetails/AdminBiddingDetails.jsx
import React, { useState, useContext } from "react";
import AppContext from "../../../context/AppContext";
import Modal from "../../../components/customer/modal/Modal";
import BidHistory from "../../../components/customer/bidHistory/bidHistory";
import RejectBiddingModal from "../../../components/admin/rejectBidddingModal/RejectBiddingModal";
import "../../../assets/css/admin/adminBiddingDetails/AdminBiddingDetails.css";

const AdminBiddingDetails = ({
  bidding,
  isOpen,
  onClose,
  onApprove,
  onReject,
  onEndEarly,
}) => {
  const [showRejectModal, setShowRejectModal] = useState(false);
  const [selectedImageIndex, setSelectedImageIndex] = useState(0);
  const { baseUrlForFile } = useContext(AppContext);

  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-PK", {
      style: "currency",
      currency: "PKR",
      minimumFractionDigits: 0,
    }).format(price);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleString("en-PK", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const handleApprove = () => {
    if (window.confirm("Are you sure you want to approve this bidding?")) {
      // Replace with: await api.approveBidding(bidding.id)
      onApprove(bidding.id);
      setTimeout(() => {
        onClose();
      }, 500);
    }
  };

  const handleReject = () => {
    setShowRejectModal(true);
  };

  const handleRejectSubmit = (reason) => {
    // Replace with: await api.rejectBidding(bidding.id, reason)
    onReject(bidding.id, reason);
    setShowRejectModal(false);
    setTimeout(() => {
      onClose();
    }, 500);
  };

  const handleEndEarly = () => {
    const reason = window.prompt("Enter reason for ending this bidding early:");
    if (reason && reason.trim()) {
      // Replace with: await api.endBiddingEarly(bidding.id, reason.trim())
      onEndEarly(bidding.id, reason.trim());
      setTimeout(() => {
        onClose();
      }, 500);
    }
  };

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} title="" size="extra-large">
        <div className="admin-biddetails-container">
          <div className="admin-biddetails-left">
            <div
              className={`admin-biddetails-status-badge admin-${bidding.adminStatus}`}
            >
              {bidding.adminStatus === "pending" && "⏳ Pending Approval"}
              {bidding.adminStatus === "approved" && "✅ Approved"}
              {bidding.adminStatus === "rejected" && "❌ Rejected"}
            </div>

            <div className="admin-biddetails-main-image">
              <span className="admin-biddetails-emoji">
                <img
                  src={`${baseUrlForFile}${bidding.adcustomerbidsimage?.[selectedImageIndex]?.bidImages}`}
                  alt={bidding.productName}
                  className="admin-biddetails-main-img"
                />
              </span>
            </div>

            {bidding.adcustomerbidsimage?.length > 1 && (
              <div className="admin-biddetails-thumbnails">
                {bidding.adcustomerbidsimage.map((image, index) => (
                  <button
                    key={index}
                    className={`admin-biddetails-thumbnail ${selectedImageIndex === index ? "active" : ""
                      }`}
                    onClick={() => setSelectedImageIndex(index)}
                  >
                    <img
                      src={`${baseUrlForFile}${image.bidImages}`}
                      alt="thumbnail"
                      className="admin-biddetails-thumbnail-img"
                    />
                  </button>
                ))}
              </div>
            )}

            <div className="admin-biddetails-seller-card">
              <h4 className="admin-biddetails-section-title">
                Seller Information
              </h4>
              <div className="admin-biddetails-seller-info">
                <div className="admin-biddetails-info-row">
                  <span className="admin-biddetails-info-label">Name:</span>
                  <span className="admin-biddetails-info-value">
                    {bidding.adcustomer?.fullName || "N/A"}
                  </span>
                </div>
                <div className="admin-biddetails-info-row">
                  <span className="admin-biddetails-info-label">Phone:</span>
                  <span className="admin-biddetails-info-value">
                    {bidding.phone || "N/A"}
                  </span>
                </div>
                <div className="admin-biddetails-info-row">
                  <span className="admin-biddetails-info-label">Email:</span>
                  <span className="admin-biddetails-info-value">
                    {bidding.adcustomer?.email || "N/A"}
                  </span>
                </div>
                <div className="admin-biddetails-info-row">
                  <span className="admin-biddetails-info-label">Location:</span>
                  <span className="admin-biddetails-info-value">
                    📍 {bidding.location}
                  </span>
                </div>
              </div>
            </div>

            {bidding.adminStatus === "pending" && (
              <div className="admin-biddetails-actions">
                <button
                  className="admin-biddetails-approve-btn"
                  onClick={handleApprove}
                >
                  ✓ Approve Bidding
                </button>
                <button
                  className="admin-biddetails-reject-btn"
                  onClick={handleReject}
                >
                  ✕ Reject Bidding
                </button>
              </div>
            )}

            {bidding.adminStatus === "approved" &&
              bidding.status === "active" && (
                <div className="admin-biddetails-actions">
                  <button
                    className="admin-biddetails-end-btn"
                    onClick={handleEndEarly}
                  >
                    🛑 End Bidding Early
                  </button>
                </div>
              )}
          </div>

          <div className="admin-biddetails-right">
            <div className="admin-biddetails-header">
              <div className="admin-biddetails-category-badge">
                {bidding.category}
              </div>
              <h2 className="admin-biddetails-title">{bidding.productName}</h2>
              <div className="admin-biddetails-condition">
                {bidding.condition}
              </div>
            </div>

            <div className="admin-biddetails-description">
              <h4 className="admin-biddetails-section-title">Description</h4>
              <p>{bidding.description}</p>
            </div>

            <div className="admin-biddetails-price-section">
              <div className="admin-biddetails-price-row">
                <div className="admin-biddetails-price-item">
                  <span className="admin-biddetails-price-label">
                    Starting Price
                  </span>
                  <span className="admin-biddetails-price-value">
                    {formatPrice(bidding.startingPrice)}
                  </span>
                </div>
                <div className="admin-biddetails-price-item">
                  <span className="admin-biddetails-price-label">
                    Current Bid
                  </span>
                  <span className="admin-biddetails-price-value admin-current">
                    {formatPrice(bidding.currentBid)}
                  </span>
                </div>
              </div>
              <div className="admin-biddetails-increment">
                Min Increment: {formatPrice(bidding.minBidIncrement || 0)}
              </div>
            </div>

            <div className="admin-biddetails-timeline">
              <h4 className="admin-biddetails-section-title">Timeline</h4>
              <div className="admin-biddetails-timeline-items">
                <div className="admin-biddetails-timeline-item">
                  <span className="admin-biddetails-timeline-label">
                    Submitted:
                  </span>
                  <span>{formatDate(bidding.created_at)}</span>
                </div>
                <div className="admin-biddetails-timeline-item">
                  <span className="admin-biddetails-timeline-label">
                    Start Date:
                  </span>
                  <span>{formatDate(bidding.startDate)}</span>
                </div>
                <div className="admin-biddetails-timeline-item">
                  <span className="admin-biddetails-timeline-label">
                    End Date:
                  </span>
                  <span>{formatDate(bidding.endDate)}</span>
                </div>
                {bidding.reviewedAt && (
                  <div className="admin-biddetails-timeline-item">
                    <span className="admin-biddetails-timeline-label">
                      Reviewed:
                    </span>
                    <span>{formatDate(bidding.reviewedAt)}</span>
                  </div>
                )}
              </div>
            </div>

            {bidding.rejectionReason && (
              <div className="admin-biddetails-rejection">
                <h4 className="admin-biddetails-section-title">
                  Rejection Reason
                </h4>
                <p>{bidding.rejectionReason}</p>
              </div>
            )}
            {bidding.adplacebid?.length > 0 && (
              <div className="admin-biddetails-history">
                <h4 className="admin-biddetails-section-title">Bid History</h4>
                <BidHistory bids={bidding.adplacebid} />
              </div>
            )}

          </div>
        </div>
      </Modal>

      {showRejectModal && (
        <RejectBiddingModal
          isOpen={showRejectModal}
          onClose={() => setShowRejectModal(false)}
          bidding={bidding}
          onReject={handleRejectSubmit}
        />
      )}
    </>
  );
};

export default AdminBiddingDetails;
